import React, { Component, useState, useEffect } from "react";
import { useHistory, useLocation } from "react-router";

import moment from "moment";
import { InputGroup } from "react-bootstrap";

import View from "../Nursery/View";

import * as Constant from "../../../Constant.js";
import axios from '@app/lib/axios';
import * as commonData from "@app/lib/common_data";

import AgGridReactEx from "@app/components/AgGridReactEx";

import AcceptContractModal from "../Component/AcceptContractModal.js";

class Tas4Admin extends Component {
    constructor(props) {
        super(props);
        window.detailContractPage = this.detailPage;
        this.state = {
            ...props,
            serviceAppList: null,
            appAuthTypeList: null,
        };
    }

    componentDidMount(){    
        this.getBaseInfo();
    }

    getBaseInfo = () => {
        commonData.getAppAuthTypeList(axios, (err, typeList) => {
            if (!err) {
                commonData.getServiceAppList(axios, (err, appList) => {
                    if (!err) {
                        this.setState({serviceAppList: appList, appAuthTypeList: typeList});
                    }
                });
            } else {
            }
        });
    };

    detailPage = (id) => {
        document.location.href = "./contract?type=view&id=" + id;
    };

    listPage = () => {
        document.location.href = "./contract?";
    };

    render() {
        const { branchId, query, serviceAppList, appAuthTypeList } = this.state;
        if(!serviceAppList && !appAuthTypeList) {
            return <></>;
        }

        if (query.type === "view") {
            return <View id={query.id} serviceAppList={serviceAppList} appAuthTypeList={appAuthTypeList} listPage={this.listPage} />;
        } else {
            return (
                <div className="dashboard-wrapper">
                    <div className="dashboard-ecommerce">
                	    <div className="container-fluid dashboard-content bg-white box-shadow-down pb-2">
                            <div className="row">
                                <div className="col-xl-8 col-lg-8 col-md-8 col-sm-12 col-12">
                                    <div className="page-header">
                                        <h2 className="pageheader-title">승인 요청 처리</h2>
                                    </div>
                                </div>
                                <div className="col-xl-4 col-lg-4 col-md-4 col-sm-12 col-12"></div>
                            </div>
                        </div>
                        <div className="container-fluid dashboard-content pb-2">
                            <WaitingList serviceAppList={serviceAppList} appAuthTypeList={appAuthTypeList} detailFunc={this.detailPage} />
                        </div>
                        {/* <div className="container-fluid dashboard-content">
                            <h3 className="mt-2">계약 원 목록</h3>
                            <NurseryList branch_id={0} query={query} detailFunc={this.detailPage} />
                        </div> */}
                    </div>
                </div>
            );
        }
    }
}

const WaitingList = ({serviceAppList, appAuthTypeList, detailFunc}) => {
    const [loadingData, setLoadingData] = useState(false);
    const [nId, setNId] = useState(0);
    const [bId, setBId] = useState(0);
    const [data, setData] = useState({
        list: [],
        total: 0,
        totalWt: 0
    });
    const history = useHistory();
    const location = useLocation();
    const [searchParam, setSearchParam] = useState({
        type: location.state && location.state.searchParam ? location.state.searchParam.type || "" : "",
        value: location.state && location.state.searchParam ? location.state.searchParam.value || "" : "",
        sort_col: location.state && location.state.searchParam ? location.state.searchParam.sort_col || "contract_date" : "contract_date",
        sort: location.state && location.state.searchParam ? location.state.searchParam.sort || "desc" : "desc",
    });
    const [tableData, setTableData] = useState(false);

    let gridApi = null;
    const onGridReady = (params) => {
        gridApi = params.api;
        const sortModel = [{ colId: searchParam.sort_col, sort: searchParam.sort }];
        gridApi.setSortModel(sortModel);
    };

    const onSortChanged = (params) => {
        const sortState = params.api.getSortModel();
        if (sortState.length != 0) {
            let searchParamNew = {...searchParam};
            searchParamNew.sort_col = sortState[0].colId;
            searchParamNew.sort = sortState[0].sort;
            setSearchParam(searchParamNew);
        }
    };

    const handleKeyPress = (e) => {
        if (e.key === 'Enter') {
            onSearch();
        }
    };
    const onSearch = () => {
        applyData(searchParam, data.list);
    };

    const applyData = (searchParam, list) => {
        var tableData = listSearch(searchParam, list);

        setTableData(tableData);
        setSearchParam(searchParam);
        if (gridApi) {
            const sortModel = [{ colId: searchParam.sort_col, sort: searchParam.sort }];
            gridApi.setSortModel(sortModel);
        }
    };

    const searchField = ["branch_name", "name", "address", "director", "code"];
    const listSearch = (searchParam, list) => {
        let tableDataNew = [];
        if (!searchParam.value) {
            tableDataNew = list;
        } else {
            list.forEach((item) => {
                searchField.forEach((field) => {
                    if (searchParam.type && item.type !== searchParam.type) {
                        return;
                    }
                    if (item[field] && item[field].indexOf(searchParam.value) >= 0) {
                        if(tableDataNew.findIndex((d) => d.id == item.id) == -1) {
                            tableDataNew.push(item);
                        }
                    }
                });
            });
        }
        return tableDataNew;
    };

    const listColumn = [
        {
            headerName: "No",
            headerClass: "bg-dark text-light",
            field: "id",
            sortable: false,
            width: 80,
            minWidth: 30,
            resizable: true,
            cellClass: "text-center",
            filter: false,
            cellRenderer: (params) => {
                return params.rowIndex + 1;
            },
        },
        {
            headerName: "계약 지사",
            headerClass: "bg-dark text-light",
            field: "branch_name",
            minWidth: 100,
            resizable: true,
            cellClass: "text-left",
            filter: false,
            cellRenderer: (param) => {
                if (param.value) return param.value;
                else return "-";
            },
        },
        {
            headerName: "원명",
            headerClass: "bg-dark text-light",
            field: "name",
            minWidth: 120,
            resizable: true,
            cellClass: "text-left",
            filter: false,
        },
        {
            headerName: "지역",
            headerClass: "bg-dark text-light",
            field: "address",
            minWidth: 150,
            resizable: true,
            cellClass: "text-left",
            filter: false,
        },
        {
            headerName: "원장 명",
            headerClass: "bg-dark text-light",
            field: "director",
            minWidth: 80,
            resizable: true,
            cellClass: "text-center",
            filter: false,
        },
        {
            headerName: "원 코드",
            headerClass: "bg-dark text-light",
            field: "code",
            minWidth: 80,
            resizable: true,
            cellClass: "text-center",
            filter: false,
        },
        {
            headerName: "승인 요청",
            headerClass: "bg-waiting",
            field: "wt",
            width: 100,
            minWidth: 100,
            resizable: true,
            cellClass: "text-center bg-waiting-90",
            filter: false,
            cellRenderer: (param) => {
                return (
                    "<a class='text-primary waiting-table-modal-accept-link' style='padding: 1px 3px; text-decoration: underline;'>" +
                    param.value +
                    "</a>"
                );
            },
        },
        {
            headerName: "계약 상품",
            headerClass: "bg-dark text-light",
            field: "products",
            minWidth: 85,
            resizable: true,
            filter: false,
            cellRenderer: (param) => {
                if (!param.value) return "-";

                const arr = param.value.split(",");
                const names = [];
                arr.forEach((a) => {
                    let name = "";
                    const sa = serviceAppList.find((sa) => sa.appId == a);
                    if(sa) {
                        name = sa.name;
                    }
                    if (name) names.push(name);
                });
                return names.join(",");
            },
        },
        {
            headerName: "승인 요청일",
            headerClass: "bg-dark text-light",
            field: "contract_date",
            minWidth: 110,
            resizable: true,
            cellClass: "text-center",
            filter: false,
        },
    ];

    useEffect(() => {
        if(appAuthTypeList && serviceAppList) {
            getData(1);
        }
    }, [serviceAppList]);

    const getData = (page) => {
        setLoadingData(true);
        axios({
            method: "get",
            url: `${Constant.API_DOMAIN}/api/contract/waiting/0?page=${page}`,
        })
            .then((res) => {
                const result = {
                    list: res.data.data.list,
                    total: res.data.data && res.data.data.list ? res.data.data.list.length : 0,
                    totalWt: res.data.data && res.data.data.list ? res.data.data && res.data.data.list.reduce((ac, current) => ac + (current.wt ? current.wt : 0), 0) : 0
                };

                setData(result);
                applyData(searchParam, result.list);
                setLoadingData(false);
            })
            .catch((error) => {
                console.log(error);
                console.error("알 수 없는 오류가 발생하였습니다. \n지속 발생시 관리자에게 문의해주세요.");
                setLoadingData(false);
            });
    };
    const openAcceptModal = (nid, bid) => {
        setNId(nid);
        setBId(bid);
    };
    const onRowClicked = (params) => {
        if (params.api.getFocusedCell().column.getColId() === "wt") {
            if(params.data.bizType && params.data.subBranchId) {
                if(window.confirm("지사 영업용 계약 정보입니다.\n승인 처리를 위해 해당 지사 페이지로 이동합니다.")) {
                    const urlBase = process.env.REACT_APP_BASE_URL;
                    document.location.href = `${urlBase}/mngr/admin/branch?type=view&id=${params.data.subBranchId}`;
                }
            } else {
                openAcceptModal(params.data.id, params.data.branch_id);
            }
        } else {
			if(detailFunc) {
                const historyState = { searchParam: { type: searchParam.type, value: searchParam.value, sort_col: searchParam.sort_col, sort: searchParam.sort } };
                history.replace(location.pathname, historyState);
				detailFunc(params.data.id);
			}
        }
    };

    return (
        <>
            <div className="row">
                <div className="col-xl-12 col-lg-12 col-md-12 col-sm-12 col-12">
                    <div className="page-header">
                        <h2 className="pageheader-title">
                            계약 승인 요청 목록{!loadingData && (
                            <span className="ml-2">
                                (총 {data && data.total ? data.total.toLocaleString() : "0"}개원 / {data && data.totalWt ? data.totalWt.toLocaleString() : "0"} 건)
                            </span>
                        )}
                        </h2>
                    </div>
                </div>
            </div>
            <div className="row">
                <div className="col-xl-8 col-lg-7 col-md-6 col-sm-12 col-12 pl-4 d-flex">
                    <h5 className="mb-0" style={{ alignSelf: "end" }}>
                        {loadingData && <span className="fa fa-spinner"></span>}
                        {!loadingData && (
                            <span>
                                {tableData ? tableData.length.toLocaleString() : "0"} / {data && data.total ? data.total.toLocaleString() : "0"}
                            </span>
                        )}
                    </h5>
                </div>
                <div className="col-xl-4 col-lg-5 col-md-6 col-sm-12 col-12 text-right">
                    <InputGroup className="input-group my-group">
                        <input
                            className="form-control"
                            type="text"
                            value={searchParam.value}
                            placeholder="지사|원명|지역|원장명|원코드"
                            onChange={(e) => {
                                const param = { ...searchParam };
                                param.value = e.target.value;
                                setSearchParam(param);
                            }}
                            onKeyPress={handleKeyPress}
                        />
                        <InputGroup.Append>
                            <input type="submit" className="btn btn-primary" value="검색" onClick={onSearch} />
                        </InputGroup.Append>
                    </InputGroup>
                </div>
            </div>
            <div className="row">
                <div className="col-xl-12 col-lg-12 col-md-12 col-sm-12 col-12">
                    <AgGridReactEx
                        columnDefs={listColumn}
                        rowData={tableData}
                        rowSelection="single"
                        height={300}
                        pagination={true}
                        paginationPageSize={50}
                        onGridReady={onGridReady}
                        onSortChanged={onSortChanged}
                        onRowClicked={onRowClicked}
                        rowClassRules={{
                            "no-contract-nursery": (params) => {
                                return params.data.ap === 0 && params.data.wt === 0;
                            },
                        }}
                        overlayNoRowsTemplate={`계약 승인 요청 건이 없습니다.`}
                    />
                    <ContractAcceptModal
                        nursery_id={nId}
                        branch_id={bId}
                        serviceAppList={serviceAppList}
                        appAuthTypeList={appAuthTypeList}
                        hide={() => {
                            openAcceptModal(0, 0);
                        }}
                    />
                </div>
            </div>
            <div className="row">
                <div className="col-xl-6 col-lg-6 col-md-6 col-sm-12 col-12">
                    <RequestList />
                </div>

                <div className="col-xl-6 col-lg-6 col-md-6 col-sm-12 col-12">
                    <ReportList />
                </div>
            </div>
        </>
    );
};

const ContractAcceptModal = ({ hide, nursery_id, branch_id, serviceAppList, appAuthTypeList }) => {
    const [loadingData, setLoadingData] = useState(false);
    const [modalId, setModalId] = useState(0);
    const [data, setData] = useState(null);
    const [waitingList, setWaitingList] = useState([]);

    useEffect(() => {
        if (nursery_id > 0 && branch_id > 0) getData();
    }, [nursery_id, branch_id]);
    const onHide = () => {
        setData(null);
        hide();
    };
    const getData = () => {
        setLoadingData(true);
        axios({
            method: "get",
            url: `${Constant.API_DOMAIN}/api/contract/list/${branch_id}/${nursery_id}`,
        })
            .then((res) => {
                const result = res.data;
                const list = result.contract;
                const bizApp = {};
                const wtList = [];
                const requestDates = [];
                result.bizApp.forEach((app) => {
                    bizApp[app] = { id: app, hasPreContractedBranch: false };
                    bizApp[app].info = serviceAppList.find((sa) => sa.key == app);
                    bizApp[app].authTypeList = appAuthTypeList[app];
                });
                result.bizApp = bizApp;
                list.forEach((c) => {
                    let isWaiting = false;
                    const auth = c.app_auth;
                    if(auth) {
                        serviceAppList.forEach((a) => {
                            if(a.contractUseTas && bizApp[a.key]) {
                                if(auth[a.key] && auth[a.key].approval === "WT") {
                                    isWaiting = true;
                                    requestDates.push(auth[a.key].contract_date);
                                }
                            }
                        });
                    }
                    if (isWaiting && !c.is555) wtList.push(c);
                    // 기존 계약 승인 정보 보관
                    if(auth) {
                        serviceAppList.forEach((a) => {
                            if(a.contractUseTas && bizApp[a.key]) {
                                if(auth[a.key] && auth[a.key].approval) {
                                    auth[a.key].approval_org = auth[a.key].approval;
                                    auth[a.key].authType_org = auth[a.key].authType;
                                    auth[a.key].authTypeName_org = auth[a.key].authTypeName;
                                }
                            }
                        });
                    }
                    // 결합 상품 정보 설정
                    if(c.unionId) {
                        c.unionSelected = appAuthTypeList.all.find((at) => at.id == c.unionId);
                    }
                });
                list.sort((a, b) => a.is555 == b.is555 ? (a.age - b.age === 0 ? a.class_name - b.class_name : a.age - b.age) : (a.is555 ? 1 : -1));
                if (requestDates.length > 0) {
                    requestDates.sort();
                    result.requestDate = requestDates[0];
                }
                setWaitingList(wtList);
                setData(result);
                setLoadingData(false);
            })
            .catch((error) => {
                console.log(error);
                console.error("알 수 없는 오류가 발생하였습니다. \n지속 발생시 관리자에게 문의해주세요.");
                setLoadingData(false);
            });
    };

    if (nursery_id === 0 || branch_id === 0) return null;

    if (data) {
        return (
            <AcceptContractModal
                nursery_id={nursery_id}
                hide={onHide}
                bizApp={data.bizApp}
                serviceAppList={serviceAppList}
                appAuthTypeList={appAuthTypeList}
                nurseryInfo={data.nursery}
                request_date={data.requestDate}
                list={data.contract}
                contain555={!data || !data.contract ? false : data.contract.filter((c) => c.is555 && c.app_auth && c.app_auth.tomobooks && c.app_auth.tomobooks == "AP").length > 0}
            />
        );
    } else {
        return null;
    }
};

const RequestList = () => {
	const [list, setList] = useState([]);
	const [loadingData, setLoadingData] = useState(false);

    const listColumn = [
        {
            headerName: "No",
            headerClass: 'bg-dark text-light',
            field: "id",
            sortable: false,
            width : 70,
            resizable : true,
            cellClass: "text-center",
            filter: false,
            cellRenderer: (params) => {
                return params.rowIndex +1;
            }
        },
        {
            headerName: "원명",
            headerClass: 'bg-dark text-light',
            field: "name",
            width : 100,
            resizable : true,
            cellClass: "text-center",
            filter: false
        },
        {
            headerName: "요청 지사",
            headerClass: 'bg-dark text-light',
            field: "branch_name",
            width : 100,
            resizable : true,
            cellClass: "text-center",
            filter: false,
            cellRenderer: (param) => {
            	if(param.value) return param.value;
            	else return '-';
            }
        },
        {
            headerName: "원장명",
            headerClass: 'bg-dark text-light',
            field: "director",
            width : 80,
            resizable : true,
            cellClass: "text-center",
            filter: false,
            cellRenderer: (param) => {
            	if(param.value) return param.value;
            	else return '-';
            }
        },
        {
            headerName: "등록일",
            headerClass: 'bg-dark text-light',
            field: "create_date",
            width : 80,
            resizable : true,
            cellClass: "text-center",
            filter: false
        }
    ];

    useEffect(() => {
		getList();
    }, []);

    const getList = () => {
    	setLoadingData(true);
    	axios({
	      method: "get",
	      url: `${Constant.API_DOMAIN}/api/nursery/request/0`
	    })
	    .then(res => {
	        setList(res.data.list);
	        setLoadingData(false);
	      })
	    .catch(error => {
	        console.log(error);
	        console.error("알 수 없는 오류가 발생하였습니다. \n지속 발생시 관리자에게 문의해주세요.");
	        setLoadingData(false);
	    });
    }

    const detailRequestPage = (id) => {
    	document.location.href = './nursery?type=request&id=' + id;
    }

    const onRowClicked = (params) => {
        return detailRequestPage(params.data.id);
    };

	return (
		<>	
			<h3 className="mt-2">
				원 등록요청 목록
				({loadingData ? 
					(
						<span className="fa fa-spinner"></span>
					)
					: list.length
				} 건)
			</h3>
			<div className="ag-theme-balham" style={{height: `200px`}}>
				<AgGridReactEx
	              columnDefs={listColumn}
	              rowData={list}
                  rowSelection="single"
                  pagination={true}
                  paginationPageSize={5}
                  onRowClicked={onRowClicked}
                  overlayNoRowsTemplate={`<span>요청 목록이 없습니다.</span>`}
	            />
	        </div>
		</>
	);
}

const ReportList = () => {
	const [list, setList] = useState([]);
	const [loadingData, setLoadingData] = useState(false);

	useEffect(() => {
		getList();
    }, []);


    const listColumn = [
        {
            headerName: "No",
            headerClass: 'bg-dark text-light',
            field: "id",
            sortable: false,
            width : 70,
            resizable : true,
            cellClass: "text-center",
            filter: false,
            cellRenderer: (params) => {
                return params.rowIndex +1;
            }
        },
        {
            headerName: "원명",
            headerClass: 'bg-dark text-light',
            field: "name",
            width : 100,
            resizable : true,
            cellClass: "text-center",
            filter: false
        },
        {
            headerName: "요청 지사",
            headerClass: 'bg-dark text-light',
            field: "branch_name",
            width : 100,
            resizable : true,
            cellClass: "text-center",
            filter: false,
            cellRenderer: (param) => {
            	if(param.value) return param.value;
            	else return '-';
            }
        },
        {
            headerName: "원장명",
            headerClass: 'bg-dark text-light',
            field: "director",
            width : 80,
            resizable : true,
            cellClass: "text-center",
            filter: false,
            cellRenderer: (param) => {
            	if(param.value) return param.value;
            	else return '-';
            }
        },
        {
            headerName: "등록일",
            headerClass: 'bg-dark text-light',
            field: "create_date",
            width : 80,
            resizable : true,
            cellClass: "text-center",
            filter: false
        }
    ];

    const getList = () => {
    	setLoadingData(true);
    	axios({
	      method: "get",
	      url: `${Constant.API_DOMAIN}/api/nursery/report/0`
	    })
	    .then(res => {
	        setList(res.data.list);
	        setLoadingData(false);
	      })
	    .catch(error => {
	        console.log(error);
	        console.error("알 수 없는 오류가 발생하였습니다. \n지속 발생시 관리자에게 문의해주세요.");
	        setLoadingData(false);
	    });
    }

    const detailReportPage = (id) => {
    	document.location.href = './nursery?type=report&id=' + id;
    }
    const onRowClicked = (params) => {
        return detailReportPage(params.data.n_u_id);
    };

    window.detailReportPage = detailReportPage;

	return (
		<>	
			<h3 className="mt-2">
				원 정보 수정요청 목록
				({loadingData ? 
					(
						<span className="fa fa-spinner"></span>
					)
					: list.length
				} 건)
			</h3>
			<div className="ag-theme-balham" style={{height: `200px`}}>
				<AgGridReactEx
	              columnDefs={listColumn}
	              rowData={list}
                  rowSelection="single"
                  pagination={true}
                  paginationPageSize={5}
                  onRowClicked={onRowClicked}
                  overlayNoRowsTemplate={`<span>요청 목록이 없습니다.</span>`}
	            />
	        </div>
		</>
	);
}

export default Tas4Admin;
